import { InfoToolTip } from '@finn/ui-components';
import { ReactNode } from 'react';

export type ListItemProps = {
  id: number;
  label: string | ReactNode;
  title: string;
  additionalInfo?: string;
};

export const KeyDataListItem = ({
  label,
  title,
  additionalInfo,
}: ListItemProps) => {
  const isNonEmptyString = typeof label !== 'string' || label.length > 0;

  return (
    <div>
      <div className="flex items-center">
        <p className="body-14-light">{title}</p>
        {additionalInfo && (
          <div className="ml-2">
            <InfoToolTip content={additionalInfo} isSmallVariant={true} />
          </div>
        )}
      </div>
      <div className="mt-2 body-14-semibold">
        {isNonEmptyString ? label : '-'}
      </div>
    </div>
  );
};
